export default __webpack_public_path__ + "static/img-data-prep-preview-6561eddb7c2dcf12576f67af560cb0a0.webp";